module.exports = __webpack_public_path__ + "static/media/Smaragdenia_Filaki_4.e1143a75.jpg";